import styled from 'styled-components';

export const CallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
`;
